import React, { useEffect, useState } from 'react'
import { Col, FormGroup, Input, Row, Alert } from 'reactstrap'
import { useFormUtils } from 'views/shared/useFormUtils'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import Switch from 'react-switch'
import PropTypes from 'prop-types'
import { isNotNumericDecimal } from 'context/Utilities'

const BulgurPackageReview = ({ item, isDisabled }) => {
  const [packaging, setPackaging] = useState({
    fkCategory: item.fkCategory,
    fkSubCategory: item.fkSubCategory,
    GrainSize: item.GrainSize,
    Organic: item.Organic,
  })
  const methods = useFormContext()
  const { onChangeReviewer, setSwitchReviewer, asterisk } = useFormUtils()
  useEffect(() => {
    if (item !== null) {
      const { category, subCategory, GrainSize, Organic } = item
      setPackaging({
        category,
        subCategory,
        GrainSize,
        Organic,
      })
    }
    // eslint-disable-next-line
    }, [item])

  return (
    <Row>
      <Col xs={6}>
        <FormGroup>
          <h6>Size {asterisk}</h6>
          <Controller
            as={Input}
            name="GrainSize"
            placeholder={'12 - 48 ounces'}
            defaultValue={packaging.GrainSize}
            control={methods.control}
            rules={{
              validate: GrainSize => GrainSize >= 12 && GrainSize <= 48,
              maxLength: {
                value: 5,
                message: '⚠ Size exceeds 5 characters.',
              },
            }}
            onKeyDown={e => {
              if (isNotNumericDecimal(e.key)) {
                e.preventDefault()
              }
            }}
            onChange={([event]) => {
              onChangeReviewer(item, event)
              return event
            }}
            disabled={isDisabled}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="GrainSize"
              message={'⚠ Size must be between 12 - 48 ounces.'}
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
      </Col>
      <Col xs={6}>
        <p>
          <strong>Organic</strong>
        </p>
        <Controller
          as={Switch}
          name="Organic"
          id="Organic"
          control={methods.control}
          defaultValue={item.Organic}
          onChange={([checked, event, id]) => {
            setSwitchReviewer(item, checked, event, id)
            return checked
          }}
          disabled={isDisabled}
        />
      </Col>
    </Row>
  )
}

BulgurPackageReview.propTypes = {
  item: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default BulgurPackageReview
